import React from "react";
import { appColors, appRadius, appType, appStatusTone } from "../../utils/appTheme";

const TONES = {
  blue: appColors.blue,
  green: appColors.green,
  red: appColors.red,
  amber: appColors.amber,
  ink3: appColors.ink3,
};

/**
 * Badge/pill al estilo app: texto + punto opcional, en color de estado.
 * tone: 'blue'|'green'|'red'|'amber'|'ink3'  ó  usar `status` para derivar el tono.
 * Peso 400.
 */
const Badge = ({ children, tone, status, dot = false, style }) => {
  const color = tone ? TONES[tone] || tone : status ? appStatusTone(status) : appColors.blue;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "6px 11px",
        borderRadius: appRadius.pill,
        border: `1px solid ${appColors.line}`,
        fontFamily: appType.fontFamily,
        fontSize: 12.5,
        fontWeight: 400,
        lineHeight: 1,
        color,
        ...style,
      }}
    >
      {dot && (
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            background: "currentColor",
          }}
        />
      )}
      {children}
    </span>
  );
};

export default Badge;
